import React from 'react'
import type { ParentProps } from 'types/explorer'
import { STEM } from '@disco/constants/Nesting'
import { AccordionWrapper } from 'components/explorer/pane/explorer-track-versions/ExplorerTrackVersions'
import type { TrackVersionsProps } from 'components/nesting/track-versions-container'
import TrackVersionsContainer from 'components/nesting/track-versions-container'
import UseWithCautionDeferredRender from 'components/ui/use-with-caution-deferred-render'
export const ShortlistTrackVersions = ({
  versions,
  stems,
  parentProps,
  mainTrack,
}: TrackVersionsProps): React.ReactNode => {
  return (
    <UseWithCautionDeferredRender>
      {versions && (
        <AccordionWrapper
          mainTrack={mainTrack}
          parentProps={parentProps}
          items={versions}
          nestingLabel={null}
          title="VERSIONS"
          open
          disablePaneOpen
        />
      )}
      {stems && (
        <AccordionWrapper
          mainTrack={mainTrack}
          parentProps={parentProps}
          items={stems}
          title="STEMS"
          nestingLabel={STEM}
          disablePaneOpen
        />
      )}
    </UseWithCautionDeferredRender>
  )
}

const ShortlistTrackVersionsContainer = ({
  parentProps,
}: {
  parentProps: ParentProps
}): React.ReactNode => (
  <TrackVersionsContainer
    parentProps={parentProps}
    component={ShortlistTrackVersions}
  />
)

export default ShortlistTrackVersionsContainer
